module.exports = __webpack_public_path__ + "img/start_3.951ff2cf.svg";